import React from 'react';
import { Panel, PanelTheme } from '../Panel';
import { ProgressSpinner } from '../ProgressSpinner';

export const ProgressSpinnerDemo: React.FC = () => {
    return (
        <div style={{ padding: '1rem', maxWidth: '500px' }}>
            <div style={{ marginTop: '20px', marginBottom: '20px' }}>
                <li style={{ color: 'grey' }}>Progress Spinner</li>
                <Panel
                    theme={PanelTheme.White}
                    width='88%'
                >
                    <ProgressSpinner />
                </Panel>
            </div>
        </div>
    );
};
